import { ReactComponent as CrossIcon } from '../../assets/icons/cross.svg';
import {
  SContainer,
  SMessage,
  SHeader,
  SHeaderContainer,
  SCrossIconContainer,
  SButton,
} from './UpdateAppRecommendationBanner.styles';
import { translate } from '../../utils/translate';
import { setIsAppUpdateRecommended } from '../../containers/CheckAppAvailable/checkAppAvailableSlice';
import { useAppDispatch } from '../../hooks';
import { SUPPORT_APP_UPDATE_URL } from '../../config/app';

export const UpdateAppRecommendationBanner = () => {
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(setIsAppUpdateRecommended(false));
  };

  return (
    <SContainer>
      <SHeaderContainer>
        <SHeader>{translate('update_app_recommendation_header')}</SHeader>
        <SCrossIconContainer onClick={close}>
          <CrossIcon className="icon" />
        </SCrossIconContainer>
      </SHeaderContainer>
      <SMessage>{translate('update_app_recommendation_message')}</SMessage>
      <SButton
        aria-label="Update app"
        type="submit"
        onClick={() => window.electronApi?.sendOpenLink(`${SUPPORT_APP_UPDATE_URL}?lang=en`)}
        tx="update_app_recommendation_button"
      />
    </SContainer>
  );
};
